<template>
    <div class="newRunPoint">
        <div class="breadcrumb">跑步点位管理 >
            <span v-if="edit === false">新增点位广告</span>
            <span v-if="edit !== false">编辑点位广告</span>
            <span>
                <el-button class="right_f" type="primary" @click="cancel">取消</el-button>
                <el-button class="right_f" type="primary" @click.once="add(0)">保存草稿</el-button>
                <el-button class="right_f" type="primary" @click.once="add(1)">发布</el-button>
            </span>
        </div>

        <div class="detail">
            <!-- 跑步点位用户输入表单 -->
            <el-form ref="runPointForm" :rules="rules" :model="runPointForm" label-width="130px">
                <el-form-item label="广告说明：" prop="description" required>
                    <el-input v-model="runPointForm.description" placeholder="广告说明" class="runPointTitle"></el-input>
                </el-form-item>

                <select-school :schObj="runPointForm.schObj" @changeVal="getVal"></select-school>

                <el-form-item label="开始时间：" required>
                    <el-date-picker v-model="runPointForm.startTime" type="date" placeholder="选择开始日期">
                    </el-date-picker>
                    <el-select v-model="runPointForm.startTimeHour" placeholder="选择开始时间">
                        <el-option v-for="item in dateHours" :label="item" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="结束时间：" required>
                    <el-date-picker v-model="runPointForm.endTime" type="date" placeholder="选择结束日期">
                    </el-date-picker>
                    <el-select v-model="runPointForm.endTimeHour" placeholder="选择结束时间">
                        <el-option v-for="item in dateHours" :label="item" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="广告曝光代码:" class="prizeContent">
                    <el-input type="textarea" :autosize="{minRows: 5}" placeholder="广告曝光代码" v-model="runPointForm.adExposingCodes">
                    </el-input>
                </el-form-item>

                <el-form-item label="跑步点位图标：" prop="fid">
                    <div style="min-width: 500px;">
                        <el-upload :action="fileActionUrl" :on-success="handleSuccess" :on-error="handleError" name="file"
                            :headers="headers" :show-file-list='false' class="mybtn">
                            <el-button v-if="!runPointForm.fid" type="primary">
                                <span>选择图片压缩包</span>
                                <br>
                                <span>（格式：.zip）</span>
                            </el-button>
                            <el-button v-if="runPointForm.fid" type="primary">
                                <span>重新上传压缩包</span>
                                <br>
                                <span>（格式：.zip）</span>
                            </el-button>
                            <span v-if="runPointForm.fid"> 已上传</span>
                        </el-upload>
                        <div class="el-loadbox">
                            <p>需要放入2x和3x图 图片实际命名示例：</p>
                            <p>未经过普通点位：</p>
                            <p>img_point_normal@2x.png</p>
                            <p>img_point_normal@3x.png</p>
                        </div>
                    </div>
                    <p>点位命名规则：</p>
                    <p class="gray">未经过普通点位：img_point_normal.png</p>
                    <p class="gray">经过的普通点位：img_point_normal_pass.png</p>
                    <p class="gray">未经过指定点位：img_point_must_normal.png</p>
                    <p class="gray">经过的指定点位：img_point_must_pass.png</p>
                    <p class="gray">起点：img_point_start.png</p>
                    <p class="gray">终点：img_point_end.png</p>
                    <br>
                    <p class="gray">未解锁的第一个点位：run_point_first_lock.png</p>
                    <p class="gray">未解锁的第二个点位：run_point_second_lock.png</p>
                    <p class="gray">未解锁的第三个点位：run_point_third_lock.png</p>
                    <p class="gray">未解锁的第四个点位：run_point_fourth_lock.png</p>
                    <p class="gray">未解锁的第五个点位：run_point_fifth_lock.png</p>
                    <br>
                    <p class="gray">已解锁的第一个点位：run_point_first.png</p>
                    <p class="gray">已解锁的第二个点位：run_point_second.png</p>
                    <p class="gray">已解锁的第三个点位：run_point_third.png</p>
                    <p class="gray">已解锁的第四个点位：run_point_fourth.png</p>
                    <p class="gray">已解锁的第五个点位：run_point_fifth.png</p>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { mapActions } from 'vuex'
    import selectSchool from "../../common/selectSch.vue"

    export default {
        data() {
            return {
                fileActionUrl: this.$util.domain + '/adminapi/v27/runningadpoint/upload/file',
                edit: false,
                operatorId: '',
                dateHours: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00',
                    '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
                runPointForm: {
                    description: "",
                    schObj: {
                        applicableCampus: "0",
                        shieldedSchools: [], //屏蔽的学校
                        openedSchools: [] //应用的学校
                    },
                    fid: "",
                    startTime: "",
                    startTimeHour: "00:00",
                    endTime: "",
                    adExposingCodes: "",
                    endTimeHour: "00:00",
                    id: "",
                },
                rules: {
                    description: [
                        { required: true, message: "请填写广告说明", trigger: 'blur' }
                    ],
                    fid: [
                        { required: true, message: '请上传点位图片压缩包', trigger: 'change' }
                    ]
                }
            }
        },
        components: { selectSchool },
        mounted() {
            this.operatorId = JSON.parse(localStorage.getItem('user')).userId;

            let url = window.location.href;

            if (url.indexOf('?') !== -1) {
                this.edit = true;
                let runPointId = this.$util.getUrlParam('runPointId');
                this.getrunPointDetail(runPointId);
            }

        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        methods: {
            ...mapActions(['SIGNOUT']),

            //获取子组件传递的参数
            getVal(res) {
                this.runPointForm.schObj = res;
            },

            /**新增跑步点位**/
            add(num) {
                //收集数据
                let startTime = new Date(new Date(this.runPointForm.startTime).format('yyyy/MM/dd ') + this.runPointForm.startTimeHour);
                let endTime = new Date(new Date(this.runPointForm.endTime).format('yyyy/MM/dd ') + this.runPointForm.endTimeHour);
                let rootUnids = [], schObj = this.runPointForm.schObj;
                let url = this.$util.domain + '/adminapi/v27/runningadpoint/add';

                let valis = this.valiFormdata(); // 验证表单数据

                if (!valis) {
                    return;
                }

                // 存储适用学校的数组
                if (schObj.applicableCampus == 0 && schObj.shieldedSchools.length) {
                    for (let i = 0; i < schObj.shieldedSchools.length; i++) {
                        rootUnids.push(schObj.shieldedSchools[i].rootUnid * 1)
                    }
                } else if (schObj.applicableCampus == 1 && schObj.openedSchools.length) {
                    for (let i = 0; i < schObj.openedSchools.length; i++) {
                        rootUnids.push(schObj.openedSchools[i].rootUnid * 1)
                    }
                }

                let requestBody = {
                    operateType: num * 1, //操作类型，0草稿，1发布
                    startTime: startTime.getTime(),
                    endTime: endTime.getTime(),
                    description: this.runPointForm.description.trim(),
                    fid: this.runPointForm.fid * 1,
                    adExposingCodes: this.runPointForm.adExposingCodes,
                    applicableCampus: schObj.applicableCampus * 1,
                    operatorId: this.operatorId * 1, // 管理员id
                    rootUnid: rootUnids
                };

                if (this.edit) {
                    requestBody.id = this.$util.getUrlParam('runPointId') * 1;
                }

                //发送添加请求
                this.$http({
                    url,
                    method: 'POST',
                    body: JSON.stringify(requestBody)
                }).then(response => {
                    if (response.data.error === 10000) {
                        location.href = '/#/yunying/runPoint/runPointManage';
                    } else {
                        this.$util.errorMsg(response.data.message);
                    }
                }).catch(response => {
                    this.$util.errorMsg(response.data.message);
                })
            },

            // 获取跑步点位详情
            getrunPointDetail(id) {

                // 发送ajax
                this.$http({
                    method: 'POST',
                    url: this.$util.domain + '/adminapi/v27/runningadpoint/detail',
                    body: JSON.stringify({
                        id: id * 1
                    })
                }).then((response) => {
                    if (response.data.error === 10000) {
                        let data = response.data.data;
                        // 讲请求数据进行赋值
                        this.runPointForm = {
                            description: data.description,
                            schObj: {
                                applicableCampus: data.applicableCampus + '',
                                shieldedSchools: [],  // 屏蔽的学校
                                openedSchools: []   // 应用的学校
                            },
                            fid: data.fid + '',
                            startTime: data.startTime,
                            adExposingCodes: data.adExposingCodes,
                            startTimeHour: new Date(data.startTime).format('hh:00'),
                            endTime: data.endTime,
                            endTimeHour: new Date(data.endTime).format('hh:00'),
                            id: data.id
                        };
                        data.applicableCampus == 0
                            ? this.runPointForm.schObj.shieldedSchools = data.campusList
                            : this.runPointForm.schObj.openedSchools = data.campusList;
                    }
                })
            },

            // 验证
            valiFormdata() {
                let startTime = new Date(new Date(this.runPointForm.startTime).format('yyyy/MM/dd ') + this.runPointForm.startTimeHour);
                let endTime = new Date(new Date(this.runPointForm.endTime).format('yyyy/MM/dd ') + this.runPointForm.endTimeHour);
                let valis = true;

                if (!this.runPointForm.description.trim()) {
                    this.$util.errorMsg("请填写广告说明");
                    return valis = false;
                }
                if (this.runPointForm.schObj.applicableCampus == '1' && this.runPointForm.schObj.openedSchools.length == 0) {
                    this.$util.errorMsg("请添加应用学校");
                    return valis = false;
                }
                if (!this.runPointForm.startTime || !this.runPointForm.endTime) {
                    this.$util.errorMsg("请填写开始时间或结束时间");
                    return valis = false;
                }
                if (startTime.getTime() > endTime.getTime()) {
                    this.$util.errorMsg("请填写正确的结束时间");
                    return valis = false;
                }
                if (!this.runPointForm.fid) {
                    this.$util.errorMsg("请上传跑步点位压缩包");
                    return valis = false;
                }
                this.$refs.runPointForm.validate((valid) => {
                    if (!valid) {
                        return valis = false;
                    }
                })
                return valis;
            },

            //取消
            cancel() {
                history.go(-1);
            },

            //上传fid文件成功钩子
            handleSuccess(response) {
                if (response.error !== 10000) {
                    this.$util.errorMsg('上传失败');
                } else {
                    this.$util.successMsg('上传成功');
                    this.runPointForm.fid = response.data + '' || '';
                }
            },

            //上传文件失败钩子
            handleError(response) {
                if (response.status === 403) {
                    this.SIGNOUT();
                    location.href = '/#';
                }
                this.$util.errorMsg('上传失败');
            }
        }
    }

</script>
<style>
    .inline {
        display: inline-block;
        margin-right: 20px;
        margin-bottom: 15px;
    }

    .runPointTitle {
        width: 40%;
    }

    .newRunPoint .el-upload {
        width: 200px;
        float: left;
    }

    .newRunPoint .mybtn .el-button--primary {
        height: 70px;
        line-height: 20px;
    }

    .el-loadbox {
        display: inline-block;
        margin-left: 30px;
        margin-bottom: 20px;
    }

    .el-loadbox p {
        margin: 0;
        line-height: 20px;
        color: red;
    }

    .newRunPoint .el-select {
        display: inline-block;
    }

    .gray {
        color: #999;
        line-height: 22px;
    }

    .newRunPoint .time {
        display: inline-block;
        width: 15%;
    }
</style>


// WEBPACK FOOTER //
// newRunPoint.vue?13f941dc